// Icon-Komponenten
export function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="feature-icon" aria-hidden="true" focusable="false">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className="phone-icon" aria-hidden="true" focusable="false">
      <rect x="7" y="2" width="10" height="20" rx="2" />
      <line x1="11" y1="5" x2="13" y2="5" />
    </svg>
  );
}

export function WifiIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className="phone-icon" aria-hidden="true" focusable="false">
      <path d="M5 12.55a11 11 0 0 1 14.08 0"/>
      <path d="M1.42 9a16 16 0 0 1 21.16 0"/>
      <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
      <circle cx="12" cy="20" r="1"/>
    </svg>
  );
}

// Category Icons
export function CategoryIcon({ category }) {
  const cls = "w-4 h-4 text-sky-50 drop-shadow-[0_0_6px_rgba(56,189,248,0.9)]";
  
  switch (category) {
    case "Junge Leute":
      return (
        <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <circle cx="8" cy="8" r="3" />
          <circle cx="16" cy="8" r="3" />
          <path d="M4 20c0-3 2-5 4-5s4 2 4 5" />
          <path d="M12 20c0-3 2-5 4-5s4 2 4 5" />
        </svg>
      );
    case "60+ Vorteil":
      return (
        <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="9" />
          <path d="M9 10.5a2 2 0 1 0 0 3" />
          <path d="M15 11.5v4" />
          <path d="M13 13.5h4" />
        </svg>
      );
    case "SOHO":
      return (
        <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <rect x="3" y="10" width="7" height="11" rx="1" />
          <rect x="14" y="3" width="7" height="18" rx="1" />
          <path d="M6.5 13h.01" />
          <path d="M6.5 16h.01" />
          <path d="M17.5 7h.01" />
          <path d="M17.5 11h.01" />
          <path d="M17.5 15h.01" />
        </svg>
      );
    default:
      return null;
  }
}
